<template>
   <div style="height:80px">
   	<!--指定车辆选择-->
		<form role="form" class="form-inline">
			<div class="col-sm-12">
				<div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="1">导入正式车辆</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="6">导入测试车辆</radio>
					</label>
                </div>
				<div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="2">设备更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="3">设备(整机)更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="4">SIM更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="5">设备导入模板</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <button type="button" class="btn btn-primary" @click="download">下载</button>
                </div>
			</div>
		</form>
		 
   </div>
</template>
<script>
import Radio from 'components/common/Radio' 
	
  export default {
    name: 'FileDownload',
    components: {
		Radio
	},
    data() {
      return {
      	 header:{
      	 	'access-token':this.$store.state.user.accesstoken
      	 },
      	 type:'',
      };
    },
    methods:{
    	download(){
			var path = process.env.EXPORT_PATH;
			var api = process.env.API_ROOT;
			var fileName = path  + api + '/noauth/download-template?fileNo=' + this.type;
			//var fileName = 'http://192.168.1.87:8888/noauth/download-template?fileNo=' + this.type;
//			var fileName = 'http://c.didigps.com/api/noauth/download-template?fileNo=' + this.type;
			var elemIF = document.createElement("iframe");   
            elemIF.src = fileName;   
            elemIF.style.display = "none";   
            document.body.appendChild(elemIF); 
		}
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FileDownload.vue?2d150752